// extracted by mini-css-extract-plugin
export default {"container":"Button_container__K9X6Y","default":"Button_default__e3o5q","alternative":"Button_alternative__aygL4","hollow":"Button_hollow__lldSL"};